
<template>
  <section class="content">


    <h4></h4>

            <div class="card">
              <!-- <h4>Status</h4> -->

                  <div class="dash">
                    <h3>{{ total }}</h3>
                    <p>Registrations</p>
                  </div>

                  <div class="dash" v-for="x in analytics">
                    <h3>{{ x.count }}</h3>
                    <p>{{ capitalizeFirstLetter(x.checkpoint) }}</p>
                  </div>

        
            </div>

          <hr>

  </section>
</template>

<script>

import $ from 'jquery';
import moment from 'moment';
import axios from 'axios';
import Autocomplete from 'vuejs-auto-complete'
import {
  globalStore
} from '../../main.js';

import PieChart from '@/components/views/PieChart.vue';
import BarChart from '@/components/views/BarChart.vue';
import InvitationsChart from '@/components/views/InvitationsChart.vue'


export default {
  components: {
    Autocomplete,
    InvitationsChart,
    PieChart,
    BarChart
  },
  data() {
    return {
      total: 0,
      analytics: []
    }},
  mounted() {

    console.log("Dashboard Component Loaded...");
   
    console.log("url: "+globalStore.url)
    console.log("clientId: "+globalStore.clientId)
    console.log("employeeId: "+globalStore.employeeId)

    // this.getInvitations();

    this.getAnalytics();
    this.GetRegistrations();

  },
  methods: {
    capitalizeFirstLetter(str) {
          if (!str) return ''; // Return empty string if the input is empty
            return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getAnalytics(){

      console.log("Get Analytics...");

      axios.get(
        globalStore.url+ `/api/conf-analytics/`+globalStore.eventId
        ).then(response => {
          console.log("Get Conf Analytics API Response");

          console.log(response)

          this.analytics = response.data;

          console.log("Analytics: "+this.analytics.length)


        });


    },
    GetRegistrations(){

console.log("Get All Registrations");

const config = {
  headers:{
    Authorization: globalStore.token,
  }
};



axios.get(
  globalStore.url+ `/api/get-all-rsvp-event/`+globalStore.eventId 
  ).then(response => {
    console.log("Get All Registrations API Response");

    console.log(response)


      this.total = response.data.length;

    


  }).catch(e => {
    alert(e);
    console.log("Error :"+JSON.stringify(e));
  });

},
  }
}
</script>

<style scoped>


.card{
  border: 1px solid rgb(207, 207, 207);
  border-radius: 5px;
  padding: 1em;
  display: flex;
  flex-direction: row;
}


.dash{
  padding: 1em;
  text-align: center;
}

.row {
  display: flex;
  flex-wrap: wrap;
}
.flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}

@media (max-width: 767px) {
  .dashboard .row > div {
    margin-bottom: 20px;
  }
}




</style>



// WEBPACK FOOTER //
// Dashboard.vue?a00a512e